import { Option } from 'types/types';
import styled from 'styled-components';

export const reactSelectPropsForHtmlLabel = {
  formatOptionLabel: (data: Option) => <SubSupWithoutShift dangerouslySetInnerHTML={{ __html: data.label }} />,
};

// Default browser styles for sub/sup cause shift of line height
const SubSupWithoutShift = styled.span`
  sub {
    vertical-align: baseline;
    position: relative;
    top: 0.33em;
  }
  sup {
    vertical-align: baseline;
    position: relative;
    top: -0.33em;
  }
`;
